import gql from 'graphql-tag'

// Good practice numero 1 in programare - keep local code in local scope. Move it to the parent scope only when it's shared
export const CountryFragment = gql`
	fragment CountryFragment on Country {
		id
		title
		slug
        continentName
        shortCode
	}
`

export const CountriesQuery = gql`
	query countries($language: Language!) {
		countries(language: $language) {
			...CountryFragment
		}
	}
	${CountryFragment}
`

export interface ICountry {
	id: number
	title: string
	slug: string
	continentName: string
	shortCode: string
}

export interface ILocation {
	id: number
	region: string
	regionSlug: string
	city: string
	citySlug: string
}